function validResult(dilutionTest) {
  return (
    (dilutionTest.input_count && dilutionTest.result_type === 1) ||
    dilutionTest.result_type === 2 ||
    dilutionTest.result_type === 3 ||
    dilutionTest.result_type === 4 ||
    dilutionTest.result_type === 5 ||
    dilutionTest.result_type === 6
  );
}

function dilutionTestParams(dilutionTests) {
  return dilutionTests.filter((dt) => validResult(dt)).map((dt) => ({
    sample_test_id: dt.sample_test_id,
    count: dt.input_count,
    not_detected: dt.result_type === 2,
    above_max_count: dt.result_type === 3,
    unreportable: dt.result_type === 4,
    tech_review: dt.result_type === 5,
    presumptive: dt.result_type === 6,
  }));
}

function clearResult(dilutionTest) {
  dilutionTest.input_count = null;
  dilutionTest.result_type = 1;
}

export { validResult, dilutionTestParams, clearResult };
